<script setup lang="ts">
import type { PropType } from 'vue'
import HomeFloatingBoxSlider from '~/layers/homepage/components/box/HomeFloatingBoxSlider.vue'
import UVideo from '~/layers/ui/components/UVideo.vue'
import type { THomeSectionSlider } from '~/layers/homepage/data/types'
import type { PaginationOptions, AutoplayOptions } from 'swiper/types'

defineProps({
  section: {
    type: Object as PropType<THomeSectionSlider>,
    required: true,
  },
})

const id = useId()

const pagination: PaginationOptions = {
  enabled: true,
  el: `#${id} .swiper-pagination`,
  clickable: true,
}

const containerRef = ref(null)
const activeIndex = ref<number>(0)
const swiper = useSwiper(containerRef)
const autoplay:AutoplayOptions = {
  delay: 5000,
  disableOnInteraction: false,
  pauseOnMouseEnter: false,
  waitForTransition: false,
}
const changeSlideHandler = () => {
  activeIndex.value = swiper.instance.value?.realIndex || 0
}
</script>

<template>
  <p class="fixed-panel__text-center_top fixed-panel__text-center">{{ section.title }}</p>
  <div
    class="slider slider--home-section slider-catalog"
    :class="{
      'slider--dark': section.isDark,
      // 'slider-brilliants': section.sliderType === 'brilliants',
      // 'slider-catalog': section.sliderType === 'constructor',
    }"
  >
    <client-only>
      <swiper-container
        ref="containerRef"
        :id
        :pagination="pagination"
        :speed="800"
        class="swiper-container"
        :class="{
          slider__brilliants: section.sliderType === 'brilliants',
          slider__catalog: section.sliderType === 'constructor',
        }"
        effect="fade"
        :fade-effect="{
          crossFade: true,
        }"
        grab-cursor
        :slides-per-view="1"
        watch-overflow
        :autoplay="autoplay"
        @swiperslidechange="changeSlideHandler"
      >
        <swiper-slide v-for="(slide, index) in section.slides" :key="slide.name" class="swiper-slide">
          <div
            class="main__picture"
            :class="{'main__picture_square': !slide.video}"
          >
            <UVideo
              v-if="slide.video"
              :autoplay="activeIndex === index"
              :isPlay="activeIndex === index"
              class="home-section-slider-video"
              muted
              playsinline
              :poster="slide.poster"
            >
              <source
                media="(min-width:1024px)"
                :src="slide.video!.desktop"
                type="video/mp4"
              />
              <source
                media="(max-width:1023px)"
                :src="slide.video!.mobile"
                type="video/mp4"
              />
            </UVideo>
            <nuxt-link class="main__picture__link" :to="slide.link">
              <URemotePicture :picture="slide.picture" class="u-remote-picture--filter" :isLazy="false" />
            </nuxt-link>
            
          </div>
          <p class="slider__title">{{ slide.name }}</p>
        </swiper-slide>
        <div class="swiper-pagination"></div>
      </swiper-container>
    </client-only>
  </div>
  <HomeFloatingBoxSlider :section />
</template>

<style lang="scss">
@use '../../../../assets/scss/components/slider' as *;

.slider {
  &--home-section {
    @media (max-width: calc(768px - 0.01px)) {
      p.slider__title {
        top: 62px;
        bottom: auto;
      }
    }
  }

  .swiper-pagination {
    position: absolute;
    width: 100%;
    text-align: center;
  }

  .swiper-pagination-bullet {
    display: inline-block;
  }
}

.video-container.home-section-slider-video {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
</style>
